import React, { Suspense, useEffect, useState } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../firebase.js';
import LoadingTransition from '../components/loading/Loading.jsx';

const Landing = React.lazy(() => import('../pages/home/Home.jsx'));
const TosAndPrivacyPolicy = React.lazy(() => import('../pages/home/legal/Legal.jsx'));
const Login = React.lazy(() => import('../pages/login/Login.jsx'));
const Profile = React.lazy(() => import('../pages/signup/SignUp.jsx'));
const MainApp = React.lazy(() => import('../pages/app/App.jsx'));
const AuthHandler = React.lazy(() => import('../components/auth/AuthHandler.jsx'));

const ProfileComponent = React.lazy(() => import('../components/profile/Profile.jsx'));
const DiscoverComponent = React.lazy(() => import('../components/feed/discover/Discover.jsx'));
const ChatsComponent = React.lazy(() => import('../components/chats/Chats.jsx'));
const ChatComponent = React.lazy(() => import('../components/chats/chat/Chat.jsx'));
const InvitationsComponent = React.lazy(() => import('../components/invitation/Invitation.jsx'));
const ResidenceComponent = React.lazy(() => import('../components/feed/residence/Residence.jsx'));

const AppRoutes = () => {

  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // listen for auth state (handles persistence automatically)
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  return (
    <Suspense fallback={<LoadingTransition/>}>
			<Routes>
        <Route path='/' element={<Landing/>} />
        <Route path='/privacy-policy' element={<TosAndPrivacyPolicy pageType="privacy"/>} />
        <Route path='/terms-of-service' element={<TosAndPrivacyPolicy pageType="tos"/>} />

        {/* if user is logged in, don't show Login page, send to /app, otherwise load login page */}
        <Route path='/login' element={ loading ? <LoadingTransition/> : (user ? <Navigate to='/app' replace={true} /> : <Login />)}/>

        {/* if user is logged in, let them see the main app... if not, kick back to base route to log in */}
        <Route path='/app' element={ loading ? <LoadingTransition/> : (user ? <MainApp /> : <Navigate to='/login' replace={true}/>) }>
          <Route index element={<ProfileComponent/>}/>{/* land on profile by default */}
          <Route path="discover-feed" element={<DiscoverComponent/>}/>
          <Route path="invitations" element={<InvitationsComponent/>}/>
          <Route path="residence-feed" element={<ResidenceComponent/>}/>
          <Route path="chats" element={<ChatsComponent/>}>
            <Route path=":id" element={<ChatComponent />} replace={true}/>
          </Route>
        </Route>

        <Route path='/create-profile' element={<Profile/>}/>

        <Route path='/auth-handler' element={<AuthHandler/>}/>

        {/* fallback */}
        <Route path='*' element={<Navigate to="/" replace={true}/>}/>

			</Routes>
		</Suspense>
  );
}

export default AppRoutes